import template from './multiLoanCqpModal.html';
import controller from './multiLoanCqpModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    clientHeaderName: '<',
  },
};
